// 作品配置与编辑器视口分离；旧 scale 是兼容字段，不能当作当前编辑缩放删除。
export function persistentPageConfig (config) {
  const value = { ...config }
  delete value.editorViewport
  return value
}

export const templatePageConfigKeys = ['width', 'height', 'backgroundColor', 'backgroundImage', 'fitType', 'canvasSize', 'info', 'mark', 'filter']
export const defaultCanvasFilter = { hue: 0, saturation: 0, brightness: 0, contrast: 0, opacity: 100, grayscale: 0 }
const object = value => value && typeof value === 'object' && !Array.isArray(value)
const filterRanges = { hue: [-180, 180], saturation: [-100, 100], brightness: [-100, 100], contrast: [-100, 100], opacity: [0, 100], grayscale: [0, 100] }

export function validateTemplatePageConfig (config, width, height) {
  if (!object(config) || Object.keys(config).some(key => !templatePageConfigKeys.includes(key)) || config.width !== width || config.height !== height) throw new Error('页面模板画布配置不正确')
  for (const [key, max] of [['backgroundColor', 128], ['backgroundImage', 2048], ['info', 2000]]) {
    if (config[key] !== undefined && (typeof config[key] !== 'string' || config[key].length > max)) throw new Error('页面模板背景或说明配置不正确')
  }
  if (config.fitType !== undefined && !['平铺', '等比例', '等宽', '等高'].includes(config.fitType)) throw new Error('页面模板适配方式不正确')
  if (config.canvasSize !== undefined && !['desktop', 'tablet', 'mobile', 'custom'].includes(config.canvasSize)) throw new Error('页面模板尺寸预设不正确')
  if (config.mark !== undefined) {
    const mark = config.mark
    if (!object(mark) || Object.keys(mark).some(key => !['show', 'text', 'fontSize', 'textStyle', 'degree'].includes(key)) ||
      (mark.show !== undefined && typeof mark.show !== 'boolean') ||
      (mark.text !== undefined && (typeof mark.text !== 'string' || mark.text.length > 512)) ||
      (mark.textStyle !== undefined && (typeof mark.textStyle !== 'string' || mark.textStyle.length > 128)) ||
      (mark.fontSize !== undefined && (!Number.isFinite(mark.fontSize) || mark.fontSize <= 0 || mark.fontSize > 512)) ||
      (mark.degree !== undefined && (!Number.isFinite(mark.degree) || Math.abs(mark.degree) > 360))) throw new Error('页面模板水印配置不正确')
  }
  if (config.filter !== undefined) {
    if (!object(config.filter) || Object.keys(config.filter).some(key => !Object.prototype.hasOwnProperty.call(filterRanges, key) || !Number.isFinite(config.filter[key]) || config.filter[key] < filterRanges[key][0] || config.filter[key] > filterRanges[key][1])) throw new Error('页面模板滤镜配置不正确')
  }
}

export function canvasFilterStyle (filter) {
  if (!object(filter)) return ''
  const values = { ...defaultCanvasFilter }
  Object.entries(filterRanges).forEach(([key, [min, max]]) => {
    if (Number.isFinite(filter[key])) values[key] = Math.min(max, Math.max(min, filter[key]))
  })
  return `hue-rotate(${values.hue}deg) saturate(${100 + values.saturation}%) brightness(${100 + values.brightness}%) contrast(${100 + values.contrast}%) opacity(${values.opacity}%) grayscale(${values.grayscale}%)`
}
